import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

export default function OfflineBanner() {
  const [offline, setOffline] = useState(!navigator.onLine);
  useEffect(() => {
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);
  return (
    <AnimatePresence>
      {offline && (
        <motion.div
          data-testid="offline-banner"
          role="status"
          initial={{ y: -20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -20, opacity: 0 }}
          className="fixed left-1/2 top-20 z-[70] -translate-x-1/2 border border-[#FF9F1C]/50 bg-[#12141C]/90 px-4 py-2 font-mono text-[9px] tracking-[0.28em] text-[#FF9F1C] backdrop-blur"
        >
          OFFLINE — SHOWING YOUR SAVED ATLAS
        </motion.div>
      )}
    </AnimatePresence>
  );
}
